export const filterConfigText = (value) => {
  if (
    Object.keys(configTranslations).filter((item) => item == value).length == 0
  ) {
    return {};
  }

  return {
    text: `${headerTypes[configTranslations[value].type]} ${
      configTranslations[value].isButton ? "Botão" : ""
    }
    ${configTranslations[value].name}`,
    description: configTranslations[value].description,
  };
};

const configTranslations = {
  relatoriosCicloSelo: {
    isButton: true,
    name: "Relatórios do Ciclo",
    type: "sistema",
    description: [
      `Libera a consulta dos relatórios do ciclo do Selo, com filtros de regional, sala e categoria.`,
      `Exige configuração geral e permissão do grupo; também pode ser administrada no seletor Relatórios Adm da tela Grupos. Salas Ouro não exibem pontos nem relatório final nesta consulta.`,
      `o campo relatoriosCicloSelo é utilizado para controle no banco`,
    ],
  },
  fechamentoSelo: {
    isButton: true,
    name: "Fechamento do Selo",
    type: "sistema",
    description: [
      `Habilita o fechamento anual, as revisões técnicas e os recursos do Selo.`,
      `O menu depende da configuração geral e da permissão do grupo. O fulladmin mantém seus privilégios; os responsáveis indicados no ciclo atuam conforme seu papel.`,
      `o campo fechamentoSelo é utilizado para controle no banco`,
    ],
  },
  acionarSuporte: {
    isButton: true,
    name: "Acionar suporte",
    type: "sistema",
    description: [
      `Libera a visualizacao da opcao 'Acionar suporte'`,
      `Na tela inicial depende apenas da configuracao geral. Na area logada depende da configuracao geral e da permissao do grupo do usuario.`,
      `o campo acionarSuporte e utilizado para controle no banco`,
    ],
  },
  acompanhamentos: {
    name: "Acompanhamentos",
    type: "cidade",
    description: [
      `Visualiza a aba 'Acompanhamentos' dentro do município`,
      `o campo acompanhamentos é utilizado para controle no banco`,
    ],
  },
  adicionarCategoriaTerritorio: {
    name: "Adicionar categoria",
    type: "territorios",
    description: [
      `Libera a possibilidade de adicionar uma nova categoria de território`,
      `o campo adicionarCategoriaTerritorio é utilizado para controle no banco`,
    ],
  },
  adicionarIniciativaTerritorio: {
    name: "Adicionar Iniciativa Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de adicionar iniciativas em um território`,
      `o campo adicionarIniciativaTerritorio é utilizado para controle no banco`,
    ],
  },
  adicionarTerritorio: {
    name: "Adicionar Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de adicionar um território`,
      `o campo adicionarTerritorio é utilizado para controle no banco`,
    ],
  },
  agenteTerritorial: {
    isButton: true,
    name: "Agente Territorial",
    type: "cidade",
    description: [
      `Visualiza o botão 'AGENTE TERRITORIAL' dentro do município`,
      `o campo agenteTerritorial é utilizado para controle no banco`,
    ],
  },
  analisarAprovadas: {
    isButton: true,
    name: "Analisar Aprovadas",
    type: "evidencia",
    description: [
      `Pode aprovar evidências dentro da aba 'Evidências -> Evidenciadas' no município`,
      `o campo analisarAprovadas é utilizado para controle no banco`,
    ],
  },
  reverterAprovadas: {
    isButton: true,
    name: "Reverter Aprovadas",
    type: "evidencia",
    description: [
      `Pode reverter a aprovação de evidências dentro da aba 'Evidências -> Evidenciadas' no município`,
      `o campo reverterAprovadas é utilizado para controle no banco`,
    ],
  },
  reverterRejeitadas: {
    isButton: true,
    name: "Reverter Rejeitadas",
    type: "evidencia",
    description: [
      `Pode reverter a rejeição de evidências dentro da aba 'Evidências -> Evidenciadas' no município`,
      `o campo reverterRejeitadas é utilizado para controle no banco`,
    ],
  },
  descartarEvidencias: {
    isButton: true,
    name: "Descartar Evidencias",
    type: "evidencia",
    description: [
      `Exibe o botao de descartar questao e evidencias nas abas Evidenciadas em Analise, Aprovadas e Rejeitadas`,
      `Para administradores, exibe a lixeira ao lado de cada arquivo na aba Rejeitadas`,
      `Depende da configuracao geral habilitada e da permissao do grupo do usuario`,
      `o campo descartarEvidencias e utilizado para controle no banco`,
    ],
  },
  analisarEvidenciadas: {
    isButton: true,
    name: "Analisar Evidenciadas",
    type: "evidencia",
    description: [
      `Pode finalizar evidências do selo dentro da aba 'Evidências' no município`,
      `o campo analisarEvidenciadas é utilizado para controle no banco`,
    ],
  },
  analisarRejeitadas: {
    isButton: true,
    name: "Analisar Rejeitadas",
    type: "evidencia",
    description: [
      `Pode rejeitar evidências dentro da aba 'Evidências' no município`,
      `o campo analisarRejeitadas é utilizado para controle no banco`,
    ],
  },
  analisarRelatorios: {
    name: "Analisar Relatorios",
    type: "menu",
    description: [
      `Libera visualização do menu (meus relatórios/analisar relatórios), porém cada um possui sua permissão separadamente`,
      `o campo analisarRelatorios é utilizado para controle no banco`,
    ],
  },
  analisarRelatoriosAdministrativos: {
    name: "Analisar Relatorios Administrativos",
    type: "menu",
    description: [
      `Libera visualização do menu (Analisar Relatórios Administrativos/Meus Relatórios Administrativos)`,
      `o campo analisarRelatoriosAdministrativos é utilizado para controle no banco`,
    ],
  },
  andamento: {
    name: "Andamento",
    type: "cidade",
    description: [
      `Libera visualização da aba 'Andamento' dentro do município`,
      `o campo andamento é utilizado para controle no banco`,
    ],
  },
  cadastroEmLote: {
    isButton: true,
    name: "Cadastro em Lote",
    type: "cidade",
    description: [
      `Libera o botão 'Cadastrar em lote' dentro do filtro na listagem de município`,
      `o campo cadastroEmLote é utilizado para controle no banco`,
    ],
  },
  calendario: {
    name: "Calendário",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Calendário' dentro do município`,
      `o campo calendario é utilizado para controle no banco`,
    ],
  },
  carregaMembrosGrupos: {
    name: "Carregar combo de membros automática",
    type: "calendario",
    description: [
      `Carregar combo de membros automática`,
      `o campo carregaMembrosGrupos é utilizado para controle no banco`,
    ],
  },
  configuracao: {
    name: "Configuração",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Configuração'`,
      `o campo configuracao é utilizado para controle no banco`,
    ],
  },
  perguntas: {
    name: "Perguntas",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Perguntas'`,
      `o campo perguntas é utilizado para controle no banco`,
    ],
  },
  dashboardAdministrativo: {
    name: "Dashboard Administrativo",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Dashboard'`,
      `o campo dashboardAdministrativo é utilizado para controle no banco`,
    ],
  },
  desabilitarUsuario: {
    isButton: true,
    name: "Desabilitar e habilitar usuário",
    type: "usuario",
    description: [
      `Libera a visualização do botão 'Bloquear Usuário/Desbloquear Usuário' do menu usuários`,
      `o campo desabilitarUsuario é utilizado para controle no banco`,
    ],
  },
  diagnosticoSelo: {
    name: "Diagnostico do Selo",
    type: "cidade",
    isButton: true,
    description: [
      `Libera a possibilidade de visualizar o mini dash de evidências e possibilidade de visualizar a fase do diagnóstico do selo`,
      `o campo diagnosticoSelo é utilizado para controle no banco`,
    ],
  },
  downloadDiagnostico: {
    name: "Diagnóstico Selo  --> Download PDF",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualizar o botão 'Download Diagnóstico' do diagnóstico do selo`,
      `o campo downloadDiagnostico é utilizado para controle no banco`,
    ],
  },
  editarCategoriaTerritorio: {
    name: "Editar categoria",
    type: "territorios",
    description: [
      `Libera a possibilidade de editar uma categoria de território`,
      `o campo editarCategoriaTerritorio é utilizado para controle no banco`,
    ],
  },
  editarIniciativaTerritorio: {
    name: "Editar Iniciativa Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de editar iniciativas em um território`,
      `o campo editarIniciativaTerritorio é utilizado para controle no banco`,
    ],
  },
  editarMunicipio: {
    isButton: true,
    name: "Editar Município",
    type: "cidade",
    description: [
      `Libera o botão 'Editar Município' dentro do município`,
      `o campo editarMunicipio é utilizado para controle no banco`,
    ],
  },
  editarMunicipioVerAD: {
    name: "Editar Município --> Visualizar campo Agente de desenvolvimento (AD)",
    type: "cidade",
    description: [
      `Visualizar campo Agente de desenvolvimento (AD) na edição do município`,
      `o campo editarMunicipioVerAD é utilizado para controle no banco`,
    ],
  },
  editarMunicipioVerAtividadeEconomica: {
    name: "Editar Município --> Visualizar Bloco de Atividades Econômicas",
    type: "cidade",
    description: [
      `Visualizar Atividades Econômicas na edição do município`,
      `o campo editarMunicipioVerAtividadeEconomica é utilizado para controle no banco`,
    ],
  },
  editarMunicipioVerDadosSocioeconomicos: {
    name: "Editar Município --> Visualizar Bloco de Dados Socioeconômicos",
    type: "cidade",
    description: [
      `Libera os campos abaixo da edição do município:`,
      `População`,
      `Orçamento`,
      `IDH`,
      `PIB`,
      `Densidade Demográfica`,
      `Renda média da população`,
      `Receita`,
      `Despesa`,
      `Número de Empresas`,
      `ME e EPP(N°)`,
      `MEI (N°)`,
      `Mei/Total (%)`,
      `IGM`,
      `Link Google Maps`,
      `Número do Contrato`,
      `o campo editarMunicipioVerDadosSocioeconomicos é utilizado para controle no banco`,
    ],
  },
  editarMunicipioVerEixos: {
    name: "Editar Município --> Visualizar campo Eixo",
    type: "cidade",
    description: [
      `Visualizar campo Eixo na edição do município`,
      `o campo editarMunicipioVerEixos é utilizado para controle no banco`,
    ],
  },
  editarMunicipioVerPrefeito: {
    name: "Editar Município --> Visualizar Bloco de edição de Prefeito ",
    type: "cidade",
    description: [
      `Libera os campos abaixo da edição do município:`,
      `Prefeito`,
      `Partido`,
      `o campo editarMunicipioVerPrefeito é utilizado para controle no banco`,
    ],
  },
  editarTerritorio: {
    name: "Editar Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de editar um território`,
      `o campo editarTerritorio é utilizado para controle no banco`,
    ],
  },
  editarTipoSolucao: {
    name: "Tipo de Solução",
    type: "menu",
    description: [
      `Libera o menu 'Tipo de Solução'`,
      `o campo editarTipoSolucao é utilizado para controle no banco`,
    ],
  },
  editaHorasUtilizadas: {
    name: "Editar horas utilizadas",
    type: "relatorio",
    description: [
      `Libera a edição do campo 'Horas Utilizadas' no cadastro/edição na aba 'Relatório' do município`,
      `o campo editaHorasUtilizadas é utilizado para controle no banco`,
    ],
  },
  editaHorasUtilizadasQuandoTarefasSemHrPredefinidas: {
    name: "Editar horas utilizadas APENAS quando não existir tarefas com horas pré-definidas",
    type: "relatorio",
    description: [
      `Libera a edição do campo 'Horas Utilizadas' no cadastro/edição na aba 'Relatório' do município, quando as tarefas não possuem horas predefinidas`,
      `o campo editaHorasUtilizadasQuandoTarefasSemHrPredefinidas é utilizado para controle no banco`,
    ],
  },
  eixos: {
    name: "Eixos",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Eixos'`,
      `o campo eixos é utilizado para controle no banco`,
    ],
  },
  encontros: {
    name: "Encontros",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Agendas/Encontros'`,
      `o campo encontros é utilizado para controle no banco`,
    ],
  },
  enviarAprovadas: {
    isButton: true,
    name: "Enviar Aprovadas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de aprovadas em evidências que não seja selo`,
      `o campo enviarAprovadas é utilizado para controle no banco`,
    ],
  },
  enviarEvidenciadas: {
    isButton: true,
    name: "Enviar Evidenciadas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de evidenciadas em evidências que não seja selo`,
      `o campo enviarEvidenciadas é utilizado para controle no banco`,
    ],
  },
  enviarRejeitadas: {
    isButton: true,
    name: "Enviar Rejeitadas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de rejeitadas em evidências`,
      `Libera os botões 'Salvar e enviar' no selo`,
      `o campo enviarRejeitadas é utilizado para controle no banco`,
    ],
  },
  enviarRespondidas: {
    isButton: true,
    name: "Enviar Respondidas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de respondidas em evidências`,
      `Libera os botões 'Salvar e enviar' no selo`,
      `o campo enviarRespondidas é utilizado para controle no banco`,
    ],
  },
  eventos: {
    name: "Eventos",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Eventos'`,
      `o campo eventos é utilizado para controle no banco`,
    ],
  },
  evidencias: {
    name: "Evidências",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Evidências' dentro do município`,
      `o campo evidencias é utilizado para controle no banco`,
    ],
  },
  recursos: {
    name: "Recursos",
    type: "cidade",
    description: [
      `Libera a visualização do menu 'Recursos' dentro do município`,
      `o campo recursos é utilizado para controle no banco`,
    ],
  },
  revisaoTecnica: {
    name: "Revisão técnica",
    type: "cidade",
    description: [
      `Libera a visualização do menu 'Revisões técnicas' dentro do município`,
      `o campo revisaoTecnica é utilizado para controle no banco`,
    ],
  },
  criarRecursos: {
    name: "Criar recursos",
    type: "cidade",
    description: [
      `Habilita o botão 'Novo recurso' para criação de recursos no município`,
      `o campo criarRecursos é utilizado para controle no banco`,
    ],
  },
  criarRevisaoTecnica: {
    name: "Criar revisões técnicas",
    type: "cidade",
    description: [
      `Habilita o botão 'Nova revisão técnica' para criação de revisões técnicas no município`,
      `o campo criarRevisaoTecnica é utilizado para controle no banco`,
    ],
  },
  analisarRecursos: {
    name: "Analisar Recursos",
    type: "cidade",
    description: [
      `Permite analisar, decidir e comentar recursos enviados pelas salas`,
      `o campo analisarRecursos é utilizado para controle no banco`,
    ],
  },
  analisarRevisaoTecnica: {
    name: "Analisar revisões técnicas",
    type: "cidade",
    description: [
      `Permite analisar, decidir e comentar revisões técnicas enviadas pelas salas`,
      `o campo analisarRevisaoTecnica é utilizado para controle no banco`,
    ],
  },
  visualizarRascunhosRecursos: {
    name: "Visualizar rascunhos de recursos",
    type: "cidade",
    description: [
      `Controla a exibição de recursos em status 'Rascunho' nas listagens`,
      `o campo visualizarRascunhosRecursos é utilizado para controle no banco`,
    ],
  },
  visualizarRascunhosRevisaoTecnica: {
    name: "Visualizar rascunhos de revisões técnicas",
    type: "cidade",
    description: [
      `Controla a exibição de revisões técnicas em status 'Rascunho' nas listagens`,
      `o campo visualizarRascunhosRevisaoTecnica é utilizado para controle no banco`,
    ],
  },
  cancelarRecursos: {
    name: "Cancelar recursos",
    type: "cidade",
    description: [
      `Libera o botão de cancelamento de recursos em elaboração ou complementação`,
      `o campo cancelarRecursos é utilizado para controle no banco`,
    ],
  },
  cancelarRevisaoTecnica: {
    name: "Cancelar revisões técnicas",
    type: "cidade",
    description: [
      `Libera o botão de cancelamento de revisões técnicas em elaboração ou complementação`,
      `o campo cancelarRevisaoTecnica é utilizado para controle no banco`,
    ],
  },
  avaliaRecursosNacionais: {
    name: "Avalia Recursos Nacionais",
    type: "cidade",
    description: [
      `Permite analisar recursos associados a critérios de Cliente Oculto (ehPerguntaClienteOculto = 1)`,
      `o campo avaliaRecursosNacionais é utilizado para controle no banco`,
    ],
  },
  avaliaRevisaoTecnicaNacional: {
    name: "Avalia Revisões Técnicas Nacionais",
    type: "cidade",
    description: [
      `Permite analisar revisões técnicas associadas a critérios de Cliente Oculto (ehPerguntaClienteOculto = 1)`,
      `o campo avaliaRevisaoTecnicaNacional é utilizado para controle no banco`,
    ],
  },
  avaliaRecursosEstaduais: {
    name: "Avalia Recursos Estaduais",
    type: "cidade",
    description: [
      `Permite analisar recursos associados a critérios padrão (ehPerguntaClienteOculto = 0)`,
      `o campo avaliaRecursosEstaduais é utilizado para controle no banco`,
    ],
  },
  avaliaRevisaoTecnicaEstadual: {
    name: "Avalia Revisões Técnicas Estaduais",
    type: "cidade",
    description: [
      `Permite analisar revisões técnicas associadas a critérios padrão (ehPerguntaClienteOculto = 0)`,
      `o campo avaliaRevisaoTecnicaEstadual é utilizado para controle no banco`,
    ],
  },
  painelRecursosEstado: {
    name: "Painel de Recursos do Estado",
    type: "menu",
    description: [
      `Libera a visualização do painel com todos os recursos abertos pelas salas do estado`,
      `o campo painelRecursosEstado é utilizado para controle no banco`,
    ],
  },
  painelIndicadoresEstadual: {
    name: "Painel de Indicadores Estadual",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Painel de Indicadores Estadual'`,
      `o campo painelIndicadoresEstadual é utilizado para controle no banco`,
    ],
  },
  infograficoUf: {
    name: "Infográfico da UF",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Infográfico da UF'`,
      `o campo infograficoUf é utilizado para controle no banco`,
    ],
  },
  painelIndicadoresNacional: {
    name: "Painel de Indicadores Nacional",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Painel de Indicadores Nacional'`,
      `o campo painelIndicadoresNacional é utilizado para controle no banco`,
    ],
  },
  radarExecucao: {
    name: "Radar de Execução",
    type: "menu",
    description: [
      `Libera o Radar de Execução em Relatórios, abaixo do Painel de Execução.`,
      `Exige configuração geral e permissão do grupo. O fulladmin respeita a ativação geral.`,
      `o campo radarExecucao é utilizado para controle no banco`,
    ],
  },
  painelExecucao: {
    name: "Painel de Execução",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Painel de Execução'`,
      `o campo painelExecucao é utilizado para controle no banco`,
    ],
  },
  paineliaian: {
    isButton: true,
    name: "Painel IA - IAN",
    type: "evidencia",
    description: [
      `Libera a visualização do botão 'Painel IA - IAN' no menu Administração`,
      `Depende da configuração geral e da permissão do grupo do usuário`,
      `o campo paineliaian é utilizado para controle no banco`,
    ],
  },
  painelRevisaoTecnicaEstado: {
    name: "Painel de Revisões Técnicas do Estado",
    type: "menu",
    description: [
      `Libera a visualização do painel com todas as revisões técnicas abertas pelas salas do estado`,
      `o campo painelRevisaoTecnicaEstado é utilizado para controle no banco`,
    ],
  },
  excluirTerritorio: {
    name: "Excluir Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de excluir um território`,
      `o campo excluirTerritorio é utilizado para controle no banco`,
    ],
  },
  exibeComunicacaoInterna: {
    name: "Soluções --> Exibir campo Comunicação Interna ao criar/editar",
    type: "termoReferencia",
    description: [
      `Libera o campo 'Comunicação Interna (CI)' no cadastro/ediçãode uma solução na aba 'Termos de Referência -> Soluções' do município`,
      `o campo exibeComunicacaoInterna é utilizado para controle no banco`,
    ],
  },
  exibeContrato: {
    name: "Libera o campo de contrato em Soluções ",
    type: "termoReferencia",
    description: [
      `Libera o campo de contrato em Soluções`,
      `o campo exibeContrato é utilizado para controle no banco`,
    ],
  },
  exibeDetalhesSolucao: {
    name: "Solução --> Libera a exibição dos campos de Tarefas/visita e horas ",
    type: "termoReferencia",
    description: [
      `Libera o campo Tarefas/visita`,
      `Libera o campo MÁXIMO DE HORAS`,
      `Libera o campo Não computa horas?`,
      `o campo exibeDetalhesSolucao é utilizado para controle no banco`,
    ],
  },
  exibirFiltro: {
    name: "Mostrar ou esconder o filtro",
    type: "listaMunicipio",
    description: [
      `Libera a possibilidade de visualizar o filtro da tela de listagem de município`,
      `o campo exibirFiltro é utilizado para controle no banco`,
    ],
  },
  exibirPfAtendida: {
    name: "Visualizar Empresas Atendidas",
    type: "relatorio",
    description: [
      `Libera o campo 'Pessoas Físicas Atendidas' no cadastro/edição na aba 'Relatório' do município`,
      `o campo exibirPfAtendida é utilizado para controle no banco`,
    ],
  },
  exibirPjAtendida: {
    name: "Visualizar Pessoas Físicas Atendidas",
    type: "relatorio",
    description: [
      `Libera o campo 'Empresas Atendida' no cadastro/edição na aba 'Relatório' do município`,
      `o campo exibirPjAtendida é utilizado para controle no banco`,
    ],
  },
  exibirSecretaria: {
    name: "Editar Município --> Exibir secretaria do municipio",
    type: "cidade",
    description: [
      `Libera a possibilidade de criar secretarias na edição do município`,
      `Possibilita visualizar a opção de escolher secretarias para uma solução`,
      `o campo exibirSecretaria é utilizado para controle no banco`,
    ],
  },
  finalizarAcompanhamento: {
    isButton: true,
    name: "Finalizar Acompanhamento",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Finalizar' dentro de Cidade -> Acompanhamento -> Escolha o acompanhamento`,
      `o campo finalizarAcompanhamento é utilizado para controle no banco`,
    ],
  },
  gerarEditarProposta: {
    name: "Proposta --> Gerar nova proposta e editar propostas",
    type: "cidade",
    description: [
      `Gerar e editar uma proposta`,
      `o campo gerarEditarProposta é utilizado para controle no banco`,
    ],
  },
  enviarAlertaNovaProposta: {
    name: "Proposta --> Enviar Alerta de Nova Proposta",
    type: "sistema",
    description: [
      `Envia alertas por e-mail para grupos configurados quando uma nova proposta é cadastrada`,
      `o campo enviarAlertaNovaProposta é utilizado para controle no banco`,
    ],
  },
  enviarEmailEvidenciaDisponivelAnalise: {
    name: "Evidências --> Enviar e-mail ao inserir evidência para análise",
    type: "sistema",
    description: [
      `Envia e-mail aos usuários com permissão de análise quando uma evidência é inserida e disponibilizada para análise`,
      `Depende também da permissão do grupo do usuário e do escopo de município/eixo`,
      `o campo enviarEmailEvidenciaDisponivelAnalise é utilizado para controle no banco`,
    ],
  },
  enviarEmailAcompanhamentoFinalizado: {
    name: "Acompanhamentos --> Enviar e-mail ao finalizar acompanhamento",
    type: "sistema",
    description: [
      `Envia e-mail aos usuários com permissão de análise quando um acompanhamento é finalizado`,
      `Depende também da permissão do grupo do usuário e do escopo de município/eixo`,
      `o campo enviarEmailAcompanhamentoFinalizado é utilizado para controle no banco`,
    ],
  },
  exibeNumeroPropostaEmVezMunicipioPropostaId: {
    name: "Proposta --> Exibe Número da Proposta em vez de municipiopropostaid",
    type: "cidade",
    description: [
      `Exibe o Número da Proposta na listagem de propostas quando disponível`,
      `o campo exibeNumeroPropostaEmVezMunicipioPropostaId é utilizado para controle no banco`,
    ],
  },
  grupo: {
    name: "Grupos",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Grupos'`,
      `o campo grupo é utilizado para controle no banco`,
    ],
  },
  grupos: {
    name: "Grupos",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Grupos' dentro do município`,
      `o campo grupos é utilizado para controle no banco`,
    ],
  },
  incluirObsevacoes: {
    name: "Incluir Observações no relatório geral",
    type: "dashboard",
    description: [
      `Libera a opção de 'Incluir Observações' no relatório geral`,
      `o campo incluirObsevacoes é utilizado para controle no banco`,
    ],
  },
  liberarMaximoEixoMA: {
    name: "Proposta --> Adicionar mais de 5 eixos em uma proposta MA",
    type: "cidade",
    description: [
      `Consegue adicionar mais de 5 eixos em uma proposta MA `,
      `o campo liberarMaximoEixoMA é utilizado para controle no banco`,
    ],
  },
  medalhas: {
    name: "Medalhas",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Medalhas'`,
      `o campo medalhas é utilizado para controle no banco`,
    ],
  },
  menuGestaoTerritorios: {
    name: "Liberar menu Gestão de Territórios",
    type: "menu",
    description: [
      `Liberar menu Gestão de Territórios`,
      `o campo menuGestaoTerritorios é utilizado para controle no banco`,
    ],
  },
  meusProcessosPagamentos: {
    name: "Meus Processos de Pagamentos",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Meus Processos de Pagamentos'`,
      `o campo meusProcessosPagamentos é utilizado para controle no banco`,
    ],
  },
  municipiosNaoVigentesRespondemPerguntasNacionais: {
    name: "Municípios não vigentes respondem só perguntas nacionais?",
    type: "sistema",
    description: [
      `Filtra as perguntas para somente nacionais na tela de acompanhamento e diagnóstico`,
      `o campo municipiosNaoVigentesRespondemPerguntasNacionais é utilizado para controle no banco`,
    ],
  },
  naoVerClienteOcultoOuro: {
    name: "Não ver Cliente Oculto em cidades Ouro",
    type: "cidade",
    description: [
      `Libera a visualização da aba de cliente oculto somente para cidades que não sejam ouro`,
      `o campo naoVerClienteOcultoOuro é utilizado para controle no banco`,
    ],
  },
  novoAcompanhamento: {
    isButton: true,
    name: "Novo Acompanhamento",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Novo Acompanhamento' dentro de Cidade -> Acompanhamento`,
      `o campo novoAcompanhamento é utilizado para controle no banco`,
    ],
  },
  novoEvento: {
    isButton: true,
    name: "Novo Evento",
    type: "calendario",
    description: [
      `Libera a visualização do botão 'novoEvento' dentro de Cidade -> Calendário`,
      `o campo novoEvento é utilizado para controle no banco`,
    ],
  },
  novoGrupo: {
    isButton: true,
    name: "Novo Grupo",
    type: "grupo",
    description: [
      `Libera a visualização do botão '+ Grupo' dentro de Cidade -> Grupos`,
      `o campo novoGrupo é utilizado para controle no banco`,
    ],
  },
  novoRelatorio: {
    isButton: true,
    name: "Novo Relatório",
    type: "relatorio",
    description: [
      `Libera a visualização do botão 'Novo Relatório' dentro de Cidade -> Relatórios`,
      `o campo novoRelatorio é utilizado para controle no banco`,
    ],
  },
  enviarAlertaNovoRelatorio: {
    name: "Relatório --> Enviar Alerta de Novo Relatório",
    type: "sistema",
    description: [
      `Envia alertas por e-mail para grupos configurados quando um novo relatório é lançado`,
      `o campo enviarAlertaNovoRelatorio é utilizado para controle no banco`,
    ],
  },
  novoRelatorioAdministrativo: {
    isButton: true,
    name: "Novo Relatório Admin.",
    type: "relatorioAdmin",
    description: [
      `Libera a visualização do botão 'Novo Relatório Administrativo' dentro de Cidade -> Relatório Administrativo`,
      `o campo novoRelatorioAdministrativo é utilizado para controle no banco`,
    ],
  },
  ocultarRelatorioAdministrativos: {
    name: "Processo de Pagamento --> Ocultar relatórios administrativos",
    type: "menu",
    description: [
      `Oculta o relatório administrativo no processo de pagamanento nas telas de criação e aprovação`,
      `o campo ocultarRelatorioAdministrativos é utilizado para controle no banco`,
    ],
  },
  pacotes: {
    name: "Pacotes",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Pacotes'`,
      `o campo pacotes é utilizado para controle no banco`,
    ],
  },
  permiteAddMunicipiosInstituicao: {
    name: "Instituição --> Visualizar campo municípios na instituição",
    type: "menu",
    description: [
      `Libera o campos município na instituição`,
      `o campo permiteAddMunicipiosInstituicao é utilizado para controle no banco`,
    ],
  },
  permiteDeletarInstituicao: {
    name: "Instituição --> Deletar",
    type: "menu",
    isButton: true,
    description: [
      `Libera a deleção no menu Instituição`,
      `o campo permiteDeletarInstituicao é utilizado para controle no banco`,
    ],
  },
  permiteEditarInstituicao: {
    name: "Instituição --> Editar",
    type: "menu",
    isButton: true,
    description: [
      `Libera a edição no menu Instituição`,
      `o campo permiteEditarInstituicao é utilizado para controle no banco`,
    ],
  },
  podeAnalisarProposta: {
    name: "Proposta --> Pode analisar proposta",
    type: "cidade",
    description: [
      `Aprovar ou rejeitar uma proposta`,
      `o campo podeAnalisarProposta é utilizado para controle no banco`,
    ],
  },
  podeAnalisarRelatorio: {
    name: "Analisar Relatório --> Pode analisar relatórios",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar o filtro por Grupo de Solução do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar o filtro por Responsável do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar o motivo da rejeição caso o status do relatorio seja igual a reprovado do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de excluir um relatório do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de analisar um relatório ao clicar sobre ele do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de finalziar uma solução do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar todos os relatórios do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de Aprovar ou Rejeitar um relatório do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar todos os relatórios dentro da aba 'Relatórios' no município`,
      `o campo podeAnalisarRelatorio é utilizado para controle no banco`,
    ],
  },
  podeAnalisarRelatorioAdmin: {
    name: "Analisar Relatório Admin --> Pode analisar relatórios admin",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Analisar/Meus Relatórios Administrativos'`,
      `Libera a possibilidade de visualizar o filtro por Responsável do menu 'Analisar Relatórios Adminsitrativos'`,
      `Libera a possibilidade de excluir um relatório admin. do menu 'Analisar Relatórios Adminsitrativos'`,
      `Libera a possibilidade de avaliar um relatório admin. do menu 'Analisar Relatórios Adminsitrativos'`,
      `Libera a possibilidade de visualizar todos os relatórios admin. do menu 'Analisar Relatórios Adminsitrativos'`,
      `o campo podeAnalisarRelatorioAdmin é utilizado para controle no banco`,
    ],
  },
  verRelatorioTelaInteira: {
    name: "Relatórios --> Ver em tela inteira",
    type: "menu",
    isButton: true,
    description: [
      `Libera a visualização do botão 'Ver em tela inteira' no modal de avaliação de relatórios e relatórios administrativos`,
      `Permite abrir o conteúdo do relatório em um modal de leitura com altura total da tela`,
      `o campo verRelatorioTelaInteira é utilizado para controle no banco`,
    ],
  },
  podeCriarEvensoSemTarefaCalendario: {
    name: "Pode criar evento sem Tarefa",
    type: "cidade",
    description: [
      `Libera a possibilidade de criar um evento sem a necessidade de uma tarefa`,
      `o campo podeCriarEvensoSemTarefaCalendario é utilizado para controle no banco`,
    ],
  },
  podeCriarTarefaApenasSemComboCalendario: {
    name: "Criar tarefa APENAS quando não existir disponíveis na combo",
    type: "calendario",
    description: [
      `Libera a possibilidade de criar tarefas na criação de um evento no calendário do município, somente quando não existir tarefas disponíveis na combo`,
      `o campo podeCriarTarefaApenasSemComboCalendario é utilizado para controle no banco`,
    ],
  },
  podeCriarTarefaNoCalendario: {
    name: "Criar tarefa",
    type: "calendario",
    description: [
      `Libera a possibilidade de criar tarefas na criação de um evento no calendário do município`,
      `o campo podeCriarTarefaNoCalendario é utilizado para controle no banco`,
    ],
  },
  podeExcluirEncontro: {
    name: "Encontros --> Pode Excluir Encontros",
    type: "menu",
    description: [
      `Libera a possibilidade de excluir encontros no menu 'Encontros'`,
      `o campo podeExcluirEncontro é utilizado para controle no banco`,
    ],
  },
  podeExcluirProposta: {
    name: "Proposta --> Pode excluir proposta",
    type: "cidade",
    description: [
      `Excluir uma proposta`,
      `o campo podeExcluirProposta é utilizado para controle no banco`,
    ],
  },
  podeExcluirRelatorio: {
    name: "Meus Relatórios --> Pode Excluir Relatórios",
    type: "menu",
    description: [
      `Libera a possibilidade de excluir relatórios no menu 'Analisar/Meus Relatórios'`,
      `o campo podeExcluirRelatorio é utilizado para controle no banco`,
    ],
  },
  podeFinalizarClienteOculto: {
    name: "Cliente Oculto --> Pode Finalizar Cliente Oculto",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Finalizar' na aba 'Cliente Oculto' no município`,
      `o campo podeFinalizarClienteOculto é utilizado para controle no banco`,
    ],
  },
  podeRetirarSolucaoPropostaPacote: {
    name: "Proposta --> Em MT pode retirar uma solução do pacote ma proposta",
    type: "solucoes",
    isButton: true,
    description: [
      `Somente para MT, libera do usuário pode excluir soluções que sejam do pacote na proposta`,
      `o campo podeRetirarSolucaoPropostaPacote é utilizado para controle no banco`,
    ],
  },
  podeSelecionarMaisDeUmUsuarioSolucao: {
    name: "Solução --> Pode selecionar mais de um responsável por solução",
    type: "termoReferencia",
    description: [
      `Libera a possibilidade de adicionar mais de um responsável na edição/criação de soluções na aba de "Termos de Referência -> Soluções" do município`,
      `o campo podeSelecionarMaisDeUmUsuarioSolucao é utilizado para controle no banco`,
    ],
  },
  podeTrocarLinkRelFim: {
    name: "Relatório Final --> Editar Link Cliente Oculto",
    type: "cidade",
    description: [
      `Libera a possibilidade de trocar o link do cliente oculto no relatório final`,
      `o campo podeTrocarLinkRelFim é utilizado para controle no banco`,
    ],
  },
  processosPagamentos: {
    name: "Processos de Pagamento",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Processos de Pagamento'`,
      `o campo processosPagamentos é utilizado para controle no banco`,
    ],
  },
  projetoseSolucoes: {
    name: "Projetos e Soluções",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Projetos e Soluções'`,
      `o campo projetoseSolucoes é utilizado para controle no banco`,
    ],
  },
  realizarDiagnostico: {
    name: "Realizar Diagnóstico",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'RESPONDER CRITÉRIOS DE AVALIAÇÃO/RESPONDER DIAGNÓSTICO' dentro do município, caso o diagnóstico não tenha sido respondido ainda.`,
      `o campo realizarDiagnostico é utilizado para controle no banco`,
    ],
  },
  reabrirCliente: {
    name: "Cliente Oculto --> Reabrir Cliente Oculto",
    type: "cidade",
    isButton: true,
    description: [
      `Libera a visualização do botão 'Reabrir Cliente Oculto' na aba 'Cliente Oculto' no município`,
      `o campo reabrirCliente é utilizado para controle no banco`,
    ],
  },
  relatorioAdministrativo: {
    name: "Relatório Administrativo",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Relatório Administrativo' dentro do município`,
      `Libera a visualização da opção 'Incluir Relatórios Administrativos' dentro do Relatório Global`,
      `o campo relatorioAdministrativo é utilizado para controle no banco`,
    ],
  },
  relatorioGeral: {
    name: "Relatório Geral",
    type: "dashboard",
    isButton: true,
    description: [
      `Libera o botão para o relatório geral no menu 'Dashboard'`,
      `o campo relatorioGeral é utilizado para controle no banco`,
    ],
  },
  relatorioGlobal: {
    isButton: true,
    name: "Relatório Global",
    type: "dashboard",
    description: [
      `Libera a visualização do botão 'Relatório Global' dentro do menu Dashboard`,
      `o campo relatorioGlobal é utilizado para controle no banco`,
    ],
  },
  relatorioMensal: {
    isButton: true,
    name: "Relatório Mensal",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Relatório Mensal' dentro do município`,
      `o campo relatorioMensal é utilizado para controle no banco`,
    ],
  },
  dadosCadastraisMunicipio: {
    isButton: true,
    name: "Dados Cadastrais",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Dados Cadastrais' dentro do município`,
      `o campo dadosCadastraisMunicipio é utilizado para controle no banco`,
    ],
  },
  planoTrabalho: {
    name: "Plano de Trabalho",
    type: "cidade",
    description: [
      `Libera o Plano de Trabalho na aba de Propostas dentro do município`,
      `o campo planoTrabalho é utilizado para controle no banco`,
    ],
  },
  relatorios: {
    name: "Relatórios",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Relatório' dentro do município`,
      `o campo relatorios é utilizado para controle no banco`,
    ],
  },
  resumoMunicipio: {
    isButton: true,
    name: "Atores do Município",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'RESUMO DO PARCEIRO/Municipio | Atores do município' dentro do município`,
      `o campo resumoMunicipio é utilizado para controle no banco`,
    ],
  },
  respondePerguntaEixoMunicipio: {
    name: "Editar Município --> Responde pergunta sobre eixos escolhidos",
    type: "cidade",
    description: [
      `Libera a visualização da pergunta 'No ano corrente o município recebeu ações do eixo?' dentro da edição do município`,
      `o campo respondePerguntaEixoMunicipio é utilizado para controle no banco`,
    ],
  },
  sala: {
    name: "Sala",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Sala' dentro do município`,
      `o campo sala é utilizado para controle no banco`,
    ],
  },
  salaEmpreendedor: {
    name: "Sala do Empreendedor",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Sala do Empreendedor'`,
      `o campo salaEmpreendedor é utilizado para controle no banco`,
    ],
  },
  salvarMunicipio: {
    isButton: true,
    name: "Editar Municipio --> Salvar",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Salvar' municipios não vigentes dentro da edição de município`,
      `o campo salvarMunicipio é utilizado para controle no banco`,
    ],
  },
  salvarMunicipioVigente: {
    isButton: true,
    name: "Editar Municipio --> Salvar (Municipios Vigente)",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Salvar' municipios vigentes dentro da edição de município`,
      `o campo salvarMunicipioVigente é utilizado para controle no banco`,
    ],
  },
  solucoes: {
    name: "Soluções",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Soluções'`,
      `o campo solucoes é utilizado para controle no banco`,
    ],
  },
  tarefaRealizada: {
    name: "Pode Gerar Tarefa Recorrente",
    type: "calendario",
    description: [
      `Pode gerar uma tarefa recorrente`,
      `o campo tarefaRealizada é utilizado para controle no banco`,
    ],
  },
  temas: {
    name: "Temas",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Temas'`,
      `o campo temas é utilizado para controle no banco`,
    ],
  },
  termoReferencia: {
    name: "Termo de Referência",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Termos de Referência' dentro do município`,
      `o campo termoReferencia é utilizado para controle no banco`,
    ],
  },
  termRefAddEvidencia: {
    name: "Adicionar Evidência",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de adicionar evidência na aba de 'Termos de Referência'`,
      `o campo termRefAddEvidencia é utilizado para controle no banco`,
    ],
  },
  termRefAddGrupoSolucao: {
    name: "Adicionar Grupo de Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de adicionar grupo de solução na aba de 'Termos de Referência'`,
      `o campo termRefAddGrupoSolucao é utilizado para controle no banco`,
    ],
  },
  termRefAddSolucao: {
    name: "Adicionar Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de adicionar solução na aba de 'Termos de Referência'`,
      `o campo termRefAddSolucao é utilizado para controle no banco`,
    ],
  },
  emailDisparadoAoVincularSolucao: {
    name: "E-mail disparado ao vincular solução",
    type: "termoReferencia",
    description: [
      `Permite disparar e-mail ao usuário quando ele for vinculado a uma solução`,
      `o campo emailDisparadoAoVincularSolucao é utilizado para controle no banco`,
    ],
  },
  termRefAddTarefa: {
    name: "Adicionar Tarefa",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de adicionar tarefa na aba de 'Termos de Referência'`,
      `o campo termRefAddTarefa é utilizado para controle no banco`,
    ],
  },
  termRefEditarEvidencia: {
    name: "Editar Evidência",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de editar evidência na aba de 'Termos de Referência'`,
      `o campo termRefEditarEvidencia é utilizado para controle no banco`,
    ],
  },
  termRefEditarGrupoSolucao: {
    name: "Editar Grupo de Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de editar grupo de solução na aba de 'Termos de Referência'`,
      `o campo termRefEditarGrupoSolucao é utilizado para controle no banco`,
    ],
  },
  termRefEditarSolucao: {
    name: "Editar Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de editar solução na aba de 'Termos de Referência'`,
      `o campo termRefEditarSolucao é utilizado para controle no banco`,
    ],
  },
  termRefEditarTarefa: {
    name: "Editar Tarefa",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de editar tarefa na aba de 'Termos de Referência'`,
      `o campo termRefEditarTarefa é utilizado para controle no banco`,
    ],
  },
  termRefExcluirEvidencia: {
    name: "Excluir Evidência",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de excluir evidência na aba de 'Termos de Referência'`,
      `o campo termRefExcluirEvidencia é utilizado para controle no banco`,
    ],
  },
  termRefExcluirGrupoSolucao: {
    name: "Excluir Grupo de Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de excluir grupo de solução na aba de 'Termos de Referência'`,
      `o campo termRefExcluirGrupoSolucao é utilizado para controle no banco`,
    ],
  },
  termRefExcluirSolucao: {
    name: "Excluir Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de excluir solução na aba de 'Termos de Referência'`,
      `o campo termRefExcluirSolucao é utilizado para controle no banco`,
    ],
  },
  termRefExcluirTarefa: {
    name: "Excluir Tarefa",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de excluir tarefa na aba de 'Termos de Referência'`,
      `o campo termRefExcluirTarefa é utilizado para controle no banco`,
    ],
  },
  termRefImportarGrupoSolucao: {
    name: "Importar Grupo de Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de importar grupo de solução na aba de 'Termos de Referência'`,
      `o campo termRefImportarGrupoSolucao é utilizado para controle no banco`,
    ],
  },
  termRefImportarSolucao: {
    name: "Importar Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de importar solução na aba de 'Termos de Referência'`,
      `o campo termRefImportarSolucao é utilizado para controle no banco`,
    ],
  },
  termRefImportarTarefa: {
    name: "Importar Tarefa",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de importar tarefa na aba de 'Termos de Referência'`,
      `o campo termRefImportarTarefa é utilizado para controle no banco`,
    ],
  },
  termRefInterromperSolucao: {
    name: "Interromper Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de interromper solução na aba de 'Termos de Referência'`,
      `o campo termRefInterromperSolucao é utilizado para controle no banco`,
    ],
  },
  umTarefaValorRelatorio: {
    name: "Salvar uma tarefa com valor de relatório",
    type: "relatorio",
    description: [
      `Vamos considerar que caso tenha apenas uma tarefa no relatório, ela seja contabilizada pelas horas do relatório e não por sua hora normal`,
      `o campo umTarefaValorRelatorio é utilizado para controle no banco`,
    ],
  },
  unidadesRegionais: {
    name: "Unidades Regionais",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Unidades Regionais'`,
      `o campo unidadesRegionais é utilizado para controle no banco`,
    ],
  },
  usuario: {
    name: "Usuarios",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Usuarios'`,
      `o campo usuario é utilizado para controle no banco`,
    ],
  },
  usuarios: {
    name: "Usuarios",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Usuarios'`,
      `o campo usuarios é utilizado para controle no banco`,
    ],
  },
  verBotaoPropostaIniciarExecucao: {
    name: "Proposta --> Pode Iniciar Execução",
    type: "city",
    isButton: true,
    description: [
      `Libera o botão de Iniciar Execução da proposta`,
      `o campo verBotaoPropostaIniciarExecucao é utilizado para controle no banco`,
    ],
  },
  verCampoInstituicaoMembro: {
    name: "Membros --> Ver campo Instituição",
    type: "cidade",
    description: [
      `Libera a combo Instituição dentro de membros`,
      `o campo verCampoInstituicaoMembro é utilizado para controle no banco`,
    ],
  },
  verClienteOculto: {
    name: "Ver Cliente Oculto",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualização da aba 'Cliente Oculto' no município`,
      `o campo verClienteOculto é utilizado para controle no banco`,
    ],
  },
  verContrato: {
    name: "Libera o campo de contrato em Rel Admin ",
    type: "relatorioAdmin",
    description: [
      `Libera o campo de contrato em Eelatório admin`,
      `o campo verContrato é utilizado para controle no banco`,
    ],
  },
  verCustoPreco: {
    name: "Ver opção de custo e preço",
    type: "solucoes",
    description: [
      `Libera o campo 'Custo' e 'Preço' no cadastro/edição de uma solução em 'Termos de Referências - > Soluções'`,
      `Libera o campo 'Custo' e 'Preço' no cadastro/edição de uma solução no menu 'Projetos e Soluções -> Soluções`,
      `o campo verCustoPreco é utilizado para controle no banco`,
    ],
  },
  verDashboardEvidencia: {
    name: "Mini Dashboard Evidências",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualizar o mini dashboard de evidências do selo no município`,
      `o campo verDashboardEvidencia é utilizado para controle no banco`,
    ],
  },
  verDataContratoSolucao: {
    name: "Soluções --> Libera campos Inicio e Fim do contrato",
    type: "termoReferencia",
    description: [
      `Libera o campo Início e Fim do contrato dentro da aba de soluções em termo de referência`,
      `o campo verDataContratoSolucao é utilizado para controle no banco`,
    ],
  },
  verDownloadPdfAcompanhamento: {
    name: "Acompanhamento --> Download PDF",
    type: "cidade",
    isButton: true,
    description: [
      `Libera o download do PDF do acompanhamento na aba de 'Acompanhamentos' do município`,
      `o campo verDownloadPdfAcompanhamento é utilizado para controle no banco`,
    ],
  },
  verDuracaoCalendario: {
    name: "Liberar duração do calendário",
    type: "calendario",
    description: [
      `Libera o campo duração do calendário na criação de um evento`,
      `o campo verDuracaoCalendario é utilizado para controle no banco`,
    ],
  },
  verEducacaoEmpreendedora: {
    name: "Visualizar menu Educação Empreendedora ",
    type: "menu",
    isButton: true,
    description: [
      `Libera a visualização do menu Educação Empreendedora`,
      `o campo verEducacaoEmpreendedora é utilizado para controle no banco`,
    ],
  },
  verEvolucaoMunicipio: {
    name: "Visualiza Evolução do Município",
    type: "cidade",
    description: [
      `Libera a visualização da "EVOLUÇÃO DO MUNICÍPIO" e seus gráficos`,
      `o campo verEvolucaoMunicipio é utilizado para controle no banco`,
    ],
  },
  verFaixaIdMunicipio: {
    name: "Editar Município --> Visualizar campo faixa",
    type: "cidade",
    description: [
      `Visualizar campo Faixa na edição do município`,
      `o campo verFaixaIdMunicipio é utilizado para controle no banco`,
    ],
  },
  verMeusRelatorios: {
    name: "Meus Relatórios",
    type: "menu",
    description: [
      `Libera o menu 'Meus Relatórios', porém é necessário a liberação da permissão "Analisar Relatorios" para funcionar`,
      `o campo verMeusRelatorios é utilizado para controle no banco`,
    ],
  },
  verMenuMeusRelatoriosAdmin: {
    name: "Ver menu relatorios admin",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Meus Relatórios Admin'`,
      `o campo verMenuMeusRelatoriosAdmin é utilizado para controle no banco`,
    ],
  },
  verMenuCategorias: {
    name: "Categorias",
    type: "menu",
    description: [
      `Libera a visualização do menu Categorias`,
      `o campo verMenuCategorias é utilizado para controle no banco`,
    ],
  },
  verMenuContrato: {
    name: "Ver menu contratos",
    type: "menu",
    description: [
      `Libera a possibilidade de ver o menu de contratos.`,
      `o campo verMenuContrato é utilizado para controle no banco`,
    ],
  },
  verMenuFaixas: {
    name: "Faixa",
    type: "menu",
    description: [
      `Visualizar o menu faixa`,
      `o campo verMenuFaixas é utilizado para controle no banco`,
    ],
  },
  verMenuInstituicao: {
    name: "Instituição",
    type: "menu",
    description: [
      `Libera a visualização do menu Instituição`,
      `o campo verMenuInstituicao é utilizado para controle no banco`,
    ],
  },
  verMenuMunicipioEixos: {
    name: "Visualizar menu Municípios Eixos ",
    type: "menu",
    isButton: true,
    description: [
      `Libera a visualização do menu do municipio eixo`,
      `o campo verMenuMunicipioEixos é utilizado para controle no banco`,
    ],
  },
  verMenuMunicipioTemas: {
    name: "Município Temas",
    type: "menu",
    description: [
      `Libera a visualização do menu Município Temas`,
      `o campo verMenuMunicipioTemas é utilizado para controle no banco`,
    ],
  },
  verMenuProposta: {
    name: " Visualizar proposta ",
    type: "cidade",
    description: [
      `Libera a aba de proposta na cidade`,
      `o campo verMenuProposta é utilizado para controle no banco`,
    ],
  },
  verParcialAcaoFinalizada: {
    name: "Editar Encontro --> Visualizar Parcial e Ação Finalizada",
    type: "calendario",
    description: [
      `Libera a possibilidade de visualizar e editar a opção de 'Parcial' ou 'Ação Finalizada' na criação/edição do evento no calendário do município`,
      `Libera a possibilidade de visualizar o "Tipo de Encontro/Agenda" na criação de um relátorio no município`,
      `Libera a possibilidade de visualizar a opção de "Apenas relatórios de Ações finalizadas" dentro do relatório global`,
      `o campo verParcialAcaoFinalizada é utilizado para controle no banco`,
    ],
  },
  verPontosAcoesAcompanhamento: {
    name: "Acompanhamento --> Visualizar Pontos e Plano de Ação ",
    type: "city",
    isButton: true,
    description: [
      `Libera a visualização dos pontos e plano de ação na listagem de acompanhamentos`,
      `o campo verPontosAcoesAcompanhamento é utilizado para controle no banco`,
    ],
  },
  verPontosObtidos: {
    name: "Ver Pontos Obtidos",
    type: "cidade",
    description: [
      `Libera a visualização de 'Pontos Obtidos' no mini dash de evidências`,
      `o campo verPontosObtidos é utilizado para controle no banco`,
    ],
  },
  verPortifolioSolucao: {
    name: "Soluções --> Libera campo Portifólio",
    type: "termoReferencia",
    description: [
      `Libera o campo Portifólio dentro da aba de soluções em termo de referência`,
      `o campo verPortifolioSolucao é utilizado para controle no banco`,
    ],
  },
  verProjetoPrateleira: {
    name: "Projetos e Solução --> Ver aba projeto",
    type: "menu",
    description: [
      `Ver a aba projeto dentro do menu de projetos e solução`,
      `o campo verProjetoPrateleira é utilizado para controle no banco`,
    ],
  },
  verRelacaoCEMunEixo: {
    name: "Municípios Eixos --> Mostrar Check Relação com CE",
    type: "menu",
    description: [
      `Libera a visualização do checkbox 'Relação com CE' na tela de municípios eixos`,
      `o campo verRelacaoCEMunEixo é utilizado para controle no banco`,
    ],
  },
  podeSalvarMunicipiosEixos: {
    name: "Municípios Eixos --> Habilitar botão salvar",
    type: "menu",
    description: [
      `Libera o botão salvar na tela de Municípios Eixos`,
      `o campo podesalvarmunicipioseixos é utilizado para controle no banco`,
    ],
  },
  podeEditarUnidadesRegionais: {
    name: "Unidades Regionais --> Editar/Excluir/Adicionar",
    type: "menu",
    description: [
      `Libera os botões de adicionar, editar e excluir na tela de Unidades Regionais`,
      `o campo podeeditarunidadesregionais é utilizado para controle no banco`,
    ],
  },
  verSolucoesExtras: {
    name: "Proposta --> Soluções Extra ",
    type: "solucoes",
    isButton: true,
    description: [
      `Libera a possibilidade de criação de soluções extras na proposta.`,
      `o campo verSolucoesExtras é utilizado para controle no banco`,
    ],
  },

  liberarCarenciaPropostaMaDataVencimentoParcela: {
    name: "Proposta --> MA --> Liberar carência da data de vencimento da parcela",
    type: "cidade",
    description: [
      `Libera a possibilidade de passar a carência da data de vencimento da parcela na proposta`,
      `o campo liberarCarenciaPropostaMaDataVencimentoParcela é utilizado para controle no banco`,
    ],
  },
  podeReenviarEmailProcessoPagamento: {
    name: "Pode Reenviar Email",
    type: "processoPagamento",
    description: [
      `Pode Reenviar email`,
      `o campo podeReenviarEmailProcessoPagamento é utilizado para controle no banco`,
    ],
  },
  // verStatusDiagnosticoSelo: {
  //   name: "Ver status da fase do diagnóstico",
  //   type: "cidade",
  //   description: [
  //     `Libera a possibilidade de visualizar a fase do diagnóstico do selo, necessário a liberação da permissão do 'Diagnostico do Selo'`,
  //   ],
  // },
  verStatusSolucao: {
    name: "Soluções --> Libera campo status contrato",
    type: "termoReferencia",
    description: [
      `Libera o campo Status dentro da aba de soluções em termo de referência`,
      `o campo verStatusSolucao é utilizado para controle no banco`,
    ],
  },
  verTipoSolucao: {
    name: "Soluções --> Exibir campo Tipo de produto.",
    type: "termoReferencia",
    description: [
      `Libera a opção de visualização e edição do campo 'Tipo de produto' na aba 'Termos de Referência -> Soluções' do município`,
      `Libera a opção de visualização e edição do campo 'Tipo de produto' no menu 'Projetos e Soluções -> Soluções'`,
      `o campo verTipoSolucao é utilizado para controle no banco`,
    ],
  },
  verTipoSolucaoComercial: {
    name: "Soluções --> Exibir campo Tipo de Solução.",
    type: "termoReferencia",
    description: [
      `Libera a opção de visualização e edição do campo 'Tipo de Solução' na aba 'Termos de Referência -> Soluções' do município`,
      `o campo verTipoSolucaoComercial é utilizado para controle no banco`,
    ],
  },
  verTodosMembrosMunicipio: {
    name: "Grupo --> Membros --> Editar/Cadastrar ver todos os membros",
    type: "cidade",
    description: [
      `Ver todos os membros de todos os municipios na hora de inserir um membro`,
      `o campo verTodosMembrosMunicipio é utilizado para controle no banco`,
    ],
  },
  visualizarTodasEvidenciasSelo: {
    isButton: true,
    name: "Selo --> Consultar evidências de todas as perguntas e pilares",
    type: "evidencia",
    description: [
      `Amplia a consulta para todas as perguntas, municípios e pilares do Selo na UF acessada. Exige habilitação na configuração geral e no grupo.`,
      `Mantém as permissões de visualização por situação. Não libera envio, avaliação, exclusão ou reversão fora do escopo original.`,
      `Não se aplica a grupos Sala/Município. O campo visualizarTodasEvidenciasSelo é utilizado para controle no banco.`,
    ],
  },
  visualizarAprovadas: {
    isButton: true,
    name: "Visualizar Aprovadas",
    type: "evidencia",
    description: [
      `Libera a visualização dos arquivos na tela de Aprovadas em Cidade -> Evidências`,
      `o campo visualizarAprovadas é utilizado para controle no banco`,
    ],
  },
  visualizarEvidenciadas: {
    isButton: true,
    name: "Visualizar Evidenciadas",
    type: "evidencia",
    description: [
      `Libera a visualização dos arquivos na tela de Evidenciadas em Cidade -> Evidências`,
      `o campo visualizarEvidenciadas é utilizado para controle no banco`,
    ],
  },
  visualizarIniciativaTerritorio: {
    name: "Visualizar Iniciativa Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de visualizar iniciativas em um território`,
      `o campo visualizarIniciativaTerritorio é utilizado para controle no banco`,
    ],
  },
  visualizarLogo: {
    name: "Visualizar Logo no Sistema",
    type: "sistema",
    description: [
      `Libera a visualização da logo do sistema em páginas e relatórios`,
      `o campo visualizarLogo é utilizado para controle no banco`,
    ],
  },
  visualizarPontosMedalha: {
    name: "Visualizar Pontos e Medalhas",
    type: "sistema",
    description: [
      `Libera a visualização dos pontos e medalhas do sistema`,
      `o campo visualizarPontosMedalha é utilizado para controle no banco`,
    ],
  },
  visualizarRejeitadas: {
    isButton: true,
    name: "Visualizar Rejeitadas",
    type: "evidencia",
    description: [
      `Libera a visualização dos arquivos na tela de Rejeitadas em Cidade -> Evidências`,
      `o campo visualizarRejeitadas é utilizado para controle no banco`,
    ],
  },
  visualizarTerritorio: {
    name: "Visualizar Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de visualizar um território`,
      `o campo visualizarTerritorio é utilizado para controle no banco`,
    ],
  },
  visualizarUsuarioDesabilitado: {
    name: "Visualizar listagem de usuário desabilitados",
    type: "usuario",
    description: [
      `Libera a visualização da lista de usuários desabilitados no menu de usuários`,
      `o campo visualizarUsuarioDesabilitado é utilizado para controle no banco`,
    ],
  },
  visualizaRelatorioFinal: {
    name: "Relatório Final",
    type: "cidade",
    description: [
      `Libera a visualização do botão "Relatório Final" dentro do município`,
      `o campo visualizaRelatorioFinal é utilizado para controle no banco`,
    ],
  },
  visualizaTarefasExecutadas: {
    name: "Visualizar tarefas já executadas",
    type: "calendario",
    description: [
      `Libera a possibilidade de visualizar tarefas já executadas nas opções de tarefas de criação/edição de um evento no calendário do município`,
      `o campo visualizaTarefasExecutadas é utilizado para controle no banco`,
    ],
  },
  visualizaTodosEncontros: {
    name: "Encontros --> Pode Visualizar todos os encontros",
    type: "menu",
    description: [
      `Libera a visualização de todos os encontros dentro do Menu -> Encontros`,
      `o campo visualizaTodosEncontros é utilizado para controle no banco`,
    ],
  },
  visualizaEixosIds: {
    name: "Visualizar Eixos Ids",
    type: "cidade",
    description: [
      `Libera a visualização dos ids dos eixos na edição do município`,
      `o campo visualizaEixosIds é utilizado para controle no banco`,
    ],
  },

  enviaPerguntaId1Selo: {
    name: "Pode enviar dados no Plano de Ação do Selo ",
    type: "evidencia",
    description: [
      `Libera o envio de dados no Plano de Ação do Selo, o que equivale ao pergunta 1`,
      `o campo enviaPerguntaId1Selo é utilizado para controle no banco`,
    ],
  },
  verMenuMunicipiosAds: {
    name: "Pode ver o menu do Municípios Ads",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Municípios Ads'`,
      `o campo verMenuMunicipiosAds é utilizado para controle no banco`,
    ],
  },
  editarMunicipiosAds: {
    name: "Pode editar agentes no Municípios Ads",
    type: "municipioAds",
    description: [
      `Necessário permissão 'Pode ver o menu do Municípios Ads'`,
      `Permite editar agentes no menu municípios ads`,
      `o campo editarMunicipiosAds é utilizado para controle no banco`,
    ],
  },
  excluirMunicipiosAds: {
    name: "Pode excluir agentes no Municípios Ads",
    type: "municipioAds",
    description: [
      `Necessário permissão 'Pode ver o menu do Municípios Ads'`,
      `Permite excluir agentes no menu municípios ads`,
      `o campo excluirMunicipiosAds é utilizado para controle no banco`,
    ],
  },
  cadastrarMunicipiosAds: {
    name: "Pode cadastrar agentes no Municípios Ads",
    type: "municipioAds",
    description: [
      `Necessário permissão 'Pode ver o menu do Municípios Ads'`,
      `Permite cadastrar agentes no menu municípios ads`,
      `o campo cadastrarMunicipiosAds é utilizado para controle no banco`,
    ],
  },
  visualizarMunicipiosAds: {
    name: "Pode visualizar agentes no Municípios Ads",
    type: "municipioAds",
    description: [
      `Necessário permissão 'Pode ver o menu do Municípios Ads'`,
      `Permite visualizar agentes no menu municípios ads`,
      `o campo visualizarMunicipiosAds é utilizado para controle no banco`,
    ],
  },
  verTipoEncontro: {
    name: "Liberar Tipo de Encontro",
    type: "calendario",
    description: [
      `Libera a visualização do tipo de encontro no calendário`,
      `o campo verTipoEncontro é utilizado para controle no banco`,
    ],
  },
  relatorioHorasRemotasHorasPresenciais: {
    name: "Mostrar horas remotas e presenciais",
    type: "relatorio",
    description: [
      `Libera a visualização das horas remotas e presenciais no relatório`,
      `o campo relatorioHorasRemotasHorasPresenciais é utilizado para controle no banco`,
    ],
  },
  verTipoSolucaoProcessoPagamento: {
    name: "Processo de Pagamento --> Ver Tipo",
    type: "processoPagamento",
    description: [
      `Libera a visualização do tipo no processo de pagamento`,
      `o campo verTipoSolucaoProcessoPagamento é utilizado para controle no banco`,
    ],
  },
  verSomenteRegional: {
    name: "Editar --> Ver somente Projeto, Imagem, IBGE, Nome e Unidade Regional",
    type: "cidade",
    description: [
      `Libera a visualização do projeto, da imagem, do código ibge, do nome do municipio e da unidade regional na listagem de municípios`,
      `O código e o nome são visiveis mas não editáveis`,
      `o campo verSomenteRegional é utilizado para controle no banco`,
    ],
  },
  podeExcluirRelatorioAprovado: {
    name: "Pode Excluir Relatório Aprovado",
    type: "relatorio",
    description: [
      `Libera a exclusão de relatórios aprovados ao analisar relatórios`,
      `o campo podeExcluirRelatorioAprovado é utilizado para controle no banco`,
    ],
  },
  podeAnalisarProcessoPagamento: {
    name: "Pode Analisar Processo de Pagamento",
    type: "processoPagamento",
    description: [
      `Libera a análise de processos de pagamento - Aprovar e Rejeitar`,
      `o campo podeAnalisarProcessoPagamento é utilizado para controle no banco`,
    ],
  },
  podeAnalisarProcessoPagamentoPorEixo: {
    isButton: true,
    name: "Pode Analisar Processo de Pagamento Por Eixo",
    type: "processoPagamento",
    description: [
      `Restringe a análise de processos de pagamento aos eixos escolhidos no cadastro do usuário.`,
      `Exige Processos de Pagamento e Pode Analisar Processo de Pagamento; o campo podeAnalisarProcessoPagamentoPorEixo é utilizado para controle no banco.`,
    ],
  },
  podeExcluirProcessoPagamentoRejeitado: {
    name: "Pode Excluir Processo de Pagamento Rejeitado",
    type: "processoPagamento",
    description: [
      `Libera a exclusao de processos de pagamento rejeitados`,
      `o campo podeExcluirProcessoPagamentoRejeitado e utilizado para controle no banco`,
    ],
  },
  podeExcluirProcessoPagamentoEmAnalise: {
    name: "Pode Excluir Processo de Pagamento em Analise",
    type: "processoPagamento",
    description: [
      `Libera a exclusao de processos de pagamento em analise`,
      `o campo podeExcluirProcessoPagamentoEmAnalise e utilizado para controle no banco`,
    ],
  },
  podeExcluirProcessoPagamentoAprovado: {
    name: "Pode Excluir Processo de Pagamento Aprovado",
    type: "processoPagamento",
    description: [
      `Libera a exclusao de processos de pagamento aprovados`,
      `o campo podeExcluirProcessoPagamentoAprovado e utilizado para controle no banco`,
    ],
  },
  visualizarConsolidado: {
    name: "Visualizar Consolidado",
    type: "cidade",
    description: [
      `Libera a visualização do consolidado de IAN`,
      `o campo visualizarConsolidado é utilizado para controle no banco`,
    ],
  },
  visualizarConsolidadoSomenteElegivel: {
    name: "Visualizar Consolidado - Somente IAN Elegível",
    type: "cidade",
    description: [
      `Libera a visualização do consolidado de IAN apenas com os municípios elegíveis`,
      `Necessário a permissão 'Visualizar Consolidado' para funcionar`,
      `o campo visualizarConsolidadoSomenteElegivel é utilizado para controle no banco`,
    ],
  },
  dadosIanStatus: {
    name: "Dados IAN -> Status",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de status em Dados IAN`,
      `o campo dadosIanStatus é utilizado para controle no banco`,
    ],
  },
  dadosIanElegivel: {
    name: "Dados IAN -> Elegível IAN",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de elegibilidade IAN em Dados IAN`,
      `o campo dadosIanElegivel é utilizado para controle no banco`,
    ],
  },
  dadosIanEixosTrabalhadosCiclo: {
    name: "Dados IAN -> Eixos trabalhados no ciclo",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de eixos trabalhados no ciclo em Dados IAN`,
      `o campo dadosIanEixosTrabalhadosCiclo é utilizado para controle no banco`,
    ],
  },
  dadosIanAdsAtivos: {
    name: "Dados IAN -> ADs ativos",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de ADs ativos em Dados IAN`,
      `o campo dadosIanAdsAtivos é utilizado para controle no banco`,
    ],
  },
  dadosIanSalasEmpreendedorAtivas: {
    name: "Dados IAN -> Salas do Empreendedor ativas",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de salas do empreendedor ativas em Dados IAN`,
      `o campo dadosIanSalasEmpreendedorAtivas é utilizado para controle no banco`,
    ],
  },
  dadosIanTerritorioEmpreendedorAtivo: {
    name: "Dados IAN -> Território Empreendedor ativo",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de território empreendedor ativo em Dados IAN`,
      `o campo dadosIanTerritorioEmpreendedorAtivo é utilizado para controle no banco`,
    ],
  },
  dadosIanIniciativasTerritorioEmpreendedor: {
    name: "Dados IAN -> Iniciativas do Território Empreendedor",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de iniciativas do território empreendedor em Dados IAN`,
      `o campo dadosIanIniciativasTerritorioEmpreendedor é utilizado para controle no banco`,
    ],
  },
  dadosIanIanMunicipio: {
    name: "Dados IAN -> IAN do Município",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de IAN do município em Dados IAN`,
      `o campo dadosIanIanMunicipio é utilizado para controle no banco`,
    ],
  },
  dadosIanIanRegional: {
    name: "Dados IAN -> IAN da Regional",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de IAN da regional em Dados IAN`,
      `o campo dadosIanIanRegional é utilizado para controle no banco`,
    ],
  },
  dadosIanIanUfMeta: {
    name: "Dados IAN -> IAN da UF / Meta",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de IAN da UF / Meta em Dados IAN`,
      `o campo dadosIanIanUfMeta é utilizado para controle no banco`,
    ],
  },
  dadosIanTemposAberturaViabilidade: {
    name: "Dados IAN -> Tempos de abertura e viabilidade",
    type: "dadosIan",
    description: [
      `Libera o card com os tempos em horas dos quesitos 3.1 e 3.2 e seus comentários ao passar o mouse`,
      `o campo dadosIanTemposAberturaViabilidade é utilizado para controle no banco`,
    ],
  },
  dadosIanMensuracao: {
    name: "Dados IAN -> Mensuração",
    type: "dadosIan",
    description: [
      `Libera a visualização do card de mensuração em Dados IAN`,
      `o campo dadosIanMensuracao é utilizado para controle no banco`,
    ],
  },
  verSomenteRecursosOuro: {
    name: "Somente sala ouro pode criar recursos",
    type: "cidade",
    description: [
      `Libera a visualização dos recursos somente para salas ouro e bloqueia a criação de recursos para salas prata e bronze`,
      `É necessário que a flag Recursos esteja ativada para que essa configuração tenha efeito`,
      `o campo verSomenteRecursosOuro é utilizado para controle no banco`,
    ],
  },
  podeAlterarPrazoEnvioEvidencias: {
    name: "Pode alterar prazo de envio de evidências",
    type: "evidencia",
    description: [
      `Libera a possibilidade de alterar o prazo de envio de evidências`,
      `o campo podeAlterarPrazoEnvioEvidencias é utilizado para controle no banco`,
    ],
  },
  analiseIaUpload: {
    isButton: true,
    name: "Analise IA no Upload",
    type: "evidencia",
    description: [
      `Exibe uma pre-analise tecnica por IA antes de concluir o upload de evidencias`,
      `O usuario pode prosseguir com o envio ou cancelar depois de revisar a pre-analise`,
      `o campo analiseIaUpload e utilizado para controle no banco`,
    ],
  },
  analiseEvidenciasIa: {
    isButton: true,
    name: "Análise de Evidências - IA",
    type: "evidencia",
    description: [
      `Libera o painel administrativo para analisar evidencias ja enviadas com apoio de IA`,
      `A permissao permite selecionar municipios, quesitos, revisar decisoes e preparar sincronizacao`,
      `o campo analiseEvidenciasIa e utilizado para controle no banco`,
    ],
  },
  analiseEvidenciasIaValidacao: {
    isButton: true,
    name: "Análise de Evidências - IA - Validação",
    type: "evidencia",
    description: [
      `Libera o painel administrativo de validação das análises de evidências por IA`,
      `A permissão permite revisar resultados, exportar relatórios e sincronizar decisões validadas`,
      `o campo analiseEvidenciasIaValidacao e utilizado para controle no banco`,
    ],
  },
  analiseRelatorioIA: {
    isButton: true,
    name: "An?lise de Relat?rio por IA ao Finalizar",
    type: "relatorio",
    description: [
      `Executa a an?lise contextual do relat?rio e dos anexos quando o usu?rio clica em Finalizar`,
      `Depende tamb?m da permiss?o AnaliseRelatorioIA no grupo do usu?rio`,
      `o campo AnaliseRelatorioIA ? utilizado para controle no banco`,
    ],
  },
  analiseEncontroIA: {
    isButton: true,
    name: "An?lise de Encontros por IA",
    type: "relatorio",
    description: [
      `Libera os recursos de an?lise de encontros vinculados ao m?dulo de relat?rios por IA`,
      `Depende tamb?m da permiss?o AnaliseEncontroIA no grupo do usu?rio`,
      `o campo AnaliseEncontroIA ? utilizado para controle no banco`,
    ],
  },
  analiseRelatoriosIa: {
    isButton: true,
    name: "M?dulo de An?lise de Relat?rios por IA",
    type: "relatorio",
    description: [
      `Ativa o m?dulo de an?lise contextual de relat?rios por IA`,
      `Funciona em conjunto com as permiss?es espec?ficas de inser??o e valida??o`,
      `o campo AnaliseRelatoriosIa ? utilizado para controle no banco`,
    ],
  },
  analiseRelatoriosIaValidacao: {
    isButton: true,
    name: "Painel de Valida??o de Relat?rios por IA",
    type: "relatorio",
    description: [
      `Libera o menu e o painel administrativo de valida??o dos relat?rios analisados pela IA`,
      `Depende tamb?m da permiss?o AnaliseRelatoriosIaValidacao no grupo do usu?rio`,
      `o campo AnaliseRelatoriosIaValidacao ? utilizado para controle no banco`,
    ],
  },
  cidadeEmpreendedoraNews: {
    isButton: true,
    name: "Cidade Empreendedora News",
    type: "relatorio",
    description: [
      `Libera o botao News para gerar e editar jornais em PDF/HTML a partir de relatorios aprovados`,
      `Depende tambem da permissao do grupo do usuario`,
      `o campo cidadeEmpreendedoraNews e utilizado para controle no banco`,
    ],
  },
};

const headerTypes = {
  calendario: "Municipio --> Cidade --> Calendário -->",
  cidade: "Municipio --> Cidade -->",
  dashboard: "Menu --> Dashboard Admin. -->",
  evidencia: "Municipio --> Cidade --> Evidência -->",
  grupo: "Municipio -- > Cidade-- > Grupos -->",
  menu: "Menu -->",
  relatorio: "Municipio -- > Cidade --> Relatório -->",
  relatorioAdmin: "Municipio -- > Cidade --> Relatório Admin.-->",
  solucoes: "Soluções -->",
  sistema: "Sistema -->",
  territorios: "Gestão de Territórios -->",
  termoReferencia: "Municipio -- > Cidade --> Termo Referen.-->",
  listaMunicipio: "Lista de Municípios -->",
  usuario: "Usuário -->",
  municipioAds: "Menu --> Municipio Ads -->",
  processoPagamento: "Menu --> Processo de Pagamento -->",
  dadosIan: "Municipio --> Cidade --> Dados IAN -->",
};

export const initialConfig = {
  relatoriosCicloSelo: false,
  fechamentoSelo: false,
  acompanhamentos: false,
  acionarSuporte: false,
  adicionarCategoriaTerritorio: false,
  adicionarIniciativaTerritorio: false,
  adicionarTerritorio: false,
  agenteTerritorial: false,
  analisarAprovadas: false,
  analisarEvidenciadas: false,
  analisarRejeitadas: false,
  analisarRelatorios: false,
  analisarRelatoriosAdministrativos: false,
  andamento: false,
  cadastroEmLote: false,
  calendario: false,
  carregaMembrosGrupos: true,
  configuracao: false,
  dashboardAdministrativo: false,
  descartarEvidencias: false,
  desabilitarUsuario: false,
  diagnosticoSelo: false,
  downloadDiagnostico: false,
  editarCategoriaTerritorio: false,
  editarIniciativaTerritorio: false,
  editarMunicipio: false,
  editarMunicipioVerAD: false,
  editarMunicipioVerAtividadeEconomica: false,
  editarMunicipioVerDadosSocioeconomicos: false,
  editarMunicipioVerEixos: false,
  editarMunicipioVerPrefeito: false,
  editarTerritorio: false,
  editarTipoSolucao: false,
  editaHorasUtilizadas: false,
  editaHorasUtilizadasQuandoTarefasSemHrPredefinidas: false,
  eixos: false,
  encontros: false,
  enviarAprovadas: false,
  enviarEvidenciadas: false,
  enviarAlertaNovaProposta: false,
  enviarAlertaNovoRelatorio: false,
  enviarEmailEvidenciaDisponivelAnalise: false,
  enviarEmailAcompanhamentoFinalizado: false,
  enviarRejeitadas: false,
  enviarRespondidas: false,
  eventos: false,
  evidencias: false,
  recursos: false,
  revisaoTecnica: false,
  criarRecursos: false,
  criarRevisaoTecnica: false,
  analisarRecursos: false,
  analisarRevisaoTecnica: false,
  visualizarRascunhosRecursos: true,
  visualizarRascunhosRevisaoTecnica: true,
  cancelarRecursos: true,
  cancelarRevisaoTecnica: true,
  avaliaRecursosNacionais: true,
  avaliaRevisaoTecnicaNacional: true,
  avaliaRecursosEstaduais: true,
  avaliaRevisaoTecnicaEstadual: true,
  painelRecursosEstado: false,
  painelIndicadoresEstadual: false,
  infograficoUf: false,
  painelIndicadoresNacional: false,
  painelExecucao: false,
  radarExecucao: false,
  paineliaian: false,
  painelRevisaoTecnicaEstado: false,
  excluirTerritorio: false,
  exibeNumeroPropostaEmVezMunicipioPropostaId: false,
  exibeComunicacaoInterna: false,
  exibeContrato: false,
  exibeDetalhesSolucao: false,
  exibirFiltro: true,
  exibirPfAtendida: false,
  exibirPjAtendida: false,
  exibirSecretaria: false,
  finalizarAcompanhamento: false,
  gerarEditarProposta: false,
  grupo: false,
  grupos: false,
  incluirObsevacoes: false,
  liberarMaximoEixoMA: false,
  medalhas: false,
  menuGestaoTerritorios: false,
  meusProcessosPagamentos: false,
  municipiosNaoVigentesRespondemPerguntasNacionais: false,
  naoVerClienteOcultoOuro: true,
  novoAcompanhamento: false,
  novoEvento: false,
  novoGrupo: false,
  novoRelatorio: false,
  novoRelatorioAdministrativo: false,
  ocultarRelatorioAdministrativos: false,
  pacotes: false,
  permiteAddMunicipiosInstituicao: false,
  permiteDeletarInstituicao: false,
  permiteEditarInstituicao: false,
  podeAnalisarProposta: false,
  podeAnalisarRelatorio: false,
  podeAnalisarRelatorioAdmin: false,
  podeCriarEventoSemTarefaCalendario: true,
  podeCriarTarefaApenasSemComboCalendario: false,
  podeCriarTarefaNoCalendario: false,
  podeExcluirEncontro: false,
  podeExcluirProposta: false,
  podeExcluirRelatorio: false,
  podeFinalizarClienteOculto: false,
  podeRetirarSolucaoPropostaPacote: false,
  podeSelecionarMaisDeUmUsuarioSolucao: false,
  podeTrocarLinkRelFim: false,
  processosPagamentos: false,
  projetoseSolucoes: false,
  realizarDiagnostico: false,
  reabrirCliente: false,
  relatorioAdministrativo: false,
  relatorioGeral: false,
  relatorioGlobal: false,
  relatorioMensal: false,
  dadosCadastraisMunicipio: false,
  relatorios: false,
  reverterProposta: false,
  resumoMunicipio: false,
  respondePerguntaEixoMunicipio: false,
  sala: false,
  salaEmpreendedor: false,
  salvarMunicipio: true,
  salvarMunicipioVigente: false,
  solucoes: false,
  tarefaRealizada: false,
  temas: false,
  termoReferencia: false,
  termRefAddEvidencia: true,
  termRefAddGrupoSolucao: true,
  termRefAddSolucao: true,
  emailDisparadoAoVincularSolucao: false,
  termRefAddTarefa: true,
  termRefEditarEvidencia: true,
  termRefEditarGrupoSolucao: true,
  termRefEditarSolucao: true,
  termRefEditarTarefa: true,
  termRefExcluirEvidencia: true,
  termRefExcluirGrupoSolucao: true,
  termRefExcluirSolucao: true,
  termRefExcluirTarefa: true,
  termRefImportarGrupoSolucao: true,
  termRefImportarSolucao: true,
  termRefImportarTarefa: true,
  termRefInterromperSolucao: true,
  temas: false,
  unidadesRegionais: false,
  umTarefaValorRelatorio: false,
  usuarios: false,
  verBotaoPropostaIniciarExecucao: false,
  verCampoInstituicaoMembro: false,
  verClienteOculto: false,
  verContrato: false,
  verCustoPreco: false,
  verDataContratoSolucao: false,
  verDownloadPdfAcompanhamento: false,
  verDuracaoCalendario: true,
  verEducacaoEmpreendedora: false,
  verEvolucaoMunicipio: true,
  verFaixaIdMunicipio: false,
  verMeusRelatorios: true,
  verMenuMeusRelatoriosAdmin: false,
  verRelatorioTelaInteira: false,
  verMenuCategorias: false,
  verMenuContrato: false,
  verMenuFaixas: false,
  verMenuInstituicao: false,
  verMenuMunicipioEixos: false,
  verMenuMunicipioTemas: false,
  verMenuProposta: false,
  planoTrabalho: false,
  verParcialAcaoFinalizada: false,
  verPontosAcoesAcompanhamento: false,
  verPontosObtidos: false,
  verPortifolioSolucao: false,
  verProjetoPrateleira: false,
  verRelacaoCEMunEixo: false,
  podeSalvarMunicipiosEixos: false,
  podeEditarUnidadesRegionais: false,
  verSolucoesExtras: false,
  verSomenteRegional: false,
  verStatusDiagnosticoSelo: false,
  verStatusSolucao: false,
  verTipoSolucao: false,
  verTipoSolucaoComercial: false,
  verTodosMembrosMunicipio: false,
  visualizarTodasEvidenciasSelo: false,
  visualizarAprovadas: false,
  visualizarEvidenciadas: false,
  visualizarIniciativaTerritorio: false,
  visualizarLogo: true,
  visualizarPontosMedalha: true,
  visualizarRejeitadas: false,
  visualizarTerritorio: false,
  visualizarUsuarioDesabilitado: false,
  visualizaRelatorioFinal: false,
  visualizaTarefasExecutadas: false,
  visualizaTodosEncontros: false,
  visualizaEixosIds: "[]",
  enviaPerguntaId1Selo: false,
  verMenuMunicipiosAds: false,
  editarMunicipiosAds: false,
  excluirMunicipiosAds: false,
  cadastrarMunicipiosAds: false,
  visualizarMunicipiosAds: false,
  liberarCarenciaPropostaMaDataVencimentoParcela: false,
  podeReenviarEmailProcessoPagamento: true,
  perguntas: false,
  verTipoEncontro: false,
  relatorioHorasRemotasHorasPresenciais: true,
  verTipoSolucaoProcessoPagamento: false,
  podeExcluirRelatorioAprovado: false,
  reverterAprovadas: false,
  reverterRejeitadas: false,
  podeAnalisarProcessoPagamento: false,
  podeAnalisarProcessoPagamentoPorEixo: false,
  podeExcluirProcessoPagamentoEmAnalise: false,
  podeExcluirProcessoPagamentoAprovado: false,
  podeExcluirProcessoPagamentoRejeitado: false,
  visualizarConsolidado: false,
  visualizarConsolidadoSomenteElegivel: false,
  dadosIanStatus: false,
  dadosIanElegivel: false,
  dadosIanEixosTrabalhadosCiclo: false,
  dadosIanAdsAtivos: false,
  dadosIanSalasEmpreendedorAtivas: false,
  dadosIanTerritorioEmpreendedorAtivo: false,
  dadosIanIniciativasTerritorioEmpreendedor: false,
  dadosIanIanMunicipio: false,
  dadosIanIanRegional: false,
  dadosIanIanUfMeta: false,
  dadosIanMensuracao: false,
  dadosIanTemposAberturaViabilidade: false,
  verSomenteRecursosOuro: false,
  podeAlterarPrazoEnvioEvidencias: false,
  analiseIaUpload: false,
  analiseEvidenciasIa: false,
  analiseEvidenciasIaValidacao: false,
  analiseRelatorioIA: false,
  analiseEncontroIA: false,
  analiseRelatoriosIa: false,
  analiseRelatoriosIaValidacao: false,
  cidadeEmpreendedoraNews: false,
};
